import clsx from "clsx";

import { LoadingCircle } from "../Icon";
import { LOADING_WRAPPER_CLASS_NAME } from "./const";
import { LoadingWrapperProps } from "./type";

export const LoadingWrapper = ({ size, styleType }: LoadingWrapperProps) => (
  <>
    <div className={LOADING_WRAPPER_CLASS_NAME({ size, styleType })} />
    <span className="absolute left-1/2 top-2/4 -translate-x-1/2 -translate-y-1/2">
      <LoadingCircle
        className={clsx("animate-spin opacity-100", styleType === "textLine" ? "!fill-grayScale-300" : "!fill-base-0")}
      />
    </span>
  </>
);
